/* eslint-disable class-methods-use-this */
import { Base } from '@studiometa/js-toolkit';
import { isDev } from '../config.js';

/**
 * BannerSlidingMessages class.
 */
export default class BannerSlidingMessages extends Base {
  static config = {
    log: isDev(),
    name: 'BannerSlidingMessages',
    refs: ['bannerSlidingMessage[]'],
  };

  /**
   * Mounted
   */
  mounted() {
    this.$log('mounted');

    const messages = [...this.$refs.bannerSlidingMessage];

    if (!messages.length) {
      return;
    }

    let currentMessagePosition = 0;

    if (messages.length > 0) {
      window.setInterval(() => {
        messages[currentMessagePosition].classList.remove('is-active');
        currentMessagePosition += 1;
        if (currentMessagePosition >= messages.length) {
          currentMessagePosition = 0;
        }
        messages[currentMessagePosition].classList.add('is-active');
      }, 5000);
    }
  }
}
